import React from "react";
import { AuthContainer } from "./AuthContainer";
import { useAuth } from "./AuthContext";
import { useApp } from "./AppContext";
import { useTranslation } from "../i18n/TranslationContext";

export function SuccessScreen() {
	const { resetAuth, authData } = useAuth();
	const {
		setIsAuthenticated,
		setUserProfile,
		setCurrentScreen,
		setUserType,
		updateOnboardingState,
	} = useApp();
	const { t } = useTranslation();

	const handleCompleteSignup = () => {
		// Set user profile from auth data
		setUserProfile({
			firstName: authData.firstName,
			lastName: authData.lastName,
			email: authData.email,
			phone: authData.phone,
			uid: "UCM001",
			dateOfBirth: authData.dateOfBirth,
			nationality: authData.nationality,
			germanLevel: authData.germanLevel,
		});

		// Set user type as new signup for clean state
		setUserType("new_signup");

		// Mark as new user for onboarding - signup flow should show onboarding
		updateOnboardingState({
			isFirstTimeUser: true,
			hasCompletedOnboarding: false,
		});

		// Mark as authenticated and reset auth flow
		setIsAuthenticated(true);

		// Redirect to Dashboard (home screen) for user choice
		setCurrentScreen("dashboard");
		resetAuth();
	};

	return (
		<AuthContainer>
			<div className="text-center">
				{/* Success Illustration */}
				<div className="mb-8 flex justify-center">
					<div className="relative w-32 h-32">
						{/* Confetti elements */}
						<div className="absolute inset-0 animate-pulse">
							<div className="absolute top-2 left-4 w-2 h-2 bg-[var(--ucm-success-green)] rounded-full"></div>
							<div className="absolute top-6 right-6 w-1 h-1 bg-[var(--ucm-warning-orange)] rounded-full"></div>
							<div className="absolute bottom-4 left-8 w-1 h-1 bg-[var(--ucm-blue-link)] rounded-full"></div>
							<div className="absolute bottom-8 right-4 w-2 h-2 bg-[var(--ucm-error-red)] rounded-full"></div>
							<div className="absolute top-12 left-12 w-1 h-1 bg-[var(--ucm-warning-orange)] rounded-full"></div>
						</div>

						{/* Main celebration icon */}
						<div className="w-32 h-32 bg-gradient-to-br from-[var(--ucm-success-green)] to-[var(--ucm-primary-teal)] rounded-full flex items-center justify-center">
							<svg
								className="w-16 h-16 text-white"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
								/>
							</svg>
						</div>
					</div>
				</div>

				<h1 className="text-[28px] font-bold text-[var(--ucm-text-dark)] mb-4 leading-tight">
					{t("successScreen.title")}
				</h1>

				<p className="text-[var(--ucm-text-medium)] mb-8 leading-relaxed">
					{t("successScreen.subtitle")}
				</p>

				<button
					onClick={handleCompleteSignup}
					className="w-full h-14 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--ucm-primary-teal)] focus:ring-offset-2"
				>
					{t("successScreen.goToHomeScreen")}
				</button>
			</div>
		</AuthContainer>
	);
}
